import React from 'react';
import moment from 'moment';

import { timeWithZoneOffset } from '@evdy/web-core/dist/lib/utils';
import TruncatedText from '@evdy/web-core/dist/components/shared/elements/TruncatedText';

import styles from './EventCTA.module.scss';

import chevronRight from '../../../public/images/icons/chevron-right.svg';

const {
  'event-cta-card': eventCTACardClass,
  'start-time': startTimeClass,
  title: titleClass
} = styles;

const EventCTA = ({ title, startDateISO, onClick, startTimeTBD }) => {
  //confirm startDateISO exists on service, older services don't use ISO
  const eventDate = !!startDateISO && timeWithZoneOffset(new Date(startDateISO));
  const momentStartDate = !!eventDate && moment(eventDate);
  const startTimeString =
    momentStartDate._isValid && !startTimeTBD
      ? `${momentStartDate.format('ddd, MMM DD')} AT ${momentStartDate.format('LT')}`
      : `${momentStartDate.format('ddd, MMM DD')}`;

  return (
    <div className={eventCTACardClass} onClick={onClick}>
      {!!startTimeString && <div className={startTimeClass}>{startTimeString}</div>}
      <div className={titleClass}>
        <TruncatedText
          disableReadMore
          disableReadLess
          lines={2}
          message={title}
          truncatedClass={titleClass}
        />
      </div>
      <img src={chevronRight} alt="right-chev-cta" />
    </div>
  );
};

export default EventCTA;
